// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientStatusPopup-module__font-s-10___Efg1b {
  font-size: 10px !important;
}

.PatientStatusPopup-module__font-s-12___WIWaV {
  font-size: 12px !important;
}

.PatientStatusPopup-module__font-s-13___YbKmV {
  font-size: 13px !important;
}

.PatientStatusPopup-module__font-s-14___M7wvE {
  font-size: 14px !important;
}

.PatientStatusPopup-module__font-s-15___ex1nF {
  font-size: 15px !important;
}

.PatientStatusPopup-module__font-s-16___XxtIg {
  font-size: 16px !important;
}

.PatientStatusPopup-module__font-s-18___C3FmU {
  font-size: 18px !important;
}

.PatientStatusPopup-module__font-s-20___BxfCM {
  font-size: 20px !important;
}

.PatientStatusPopup-module__font-s-22___oaZB3 {
  font-size: 22px !important;
}

.PatientStatusPopup-module__font-s-28___ZnMtG {
  font-size: 28px !important;
}

.PatientStatusPopup-module__font-w-400___B4KgP {
  font-weight: 400 !important;
}

.PatientStatusPopup-module__font-w-500___tLRYz {
  font-weight: 500 !important;
}

.PatientStatusPopup-module__font-w-600___tiEUX {
  font-weight: 600 !important;
}

.PatientStatusPopup-module__font-w-700___sGzom {
  font-weight: 700 !important;
}

.PatientStatusPopup-module__p-5___INZUo {
  padding: 5px !important;
}

.PatientStatusPopup-module__p-12___v4aeF {
  padding: 12px !important;
}

.PatientStatusPopup-module__p-16___rCpEz {
  padding: 16px !important;
}

.PatientStatusPopup-module__p-30___ijJJh {
  padding: 30px !important;
}

.PatientStatusPopup-module__p-b-0___fWNig {
  padding-bottom: 0 !important;
}

.PatientStatusPopup-module__p-b-5___ALaYa {
  padding-bottom: 5px !important;
}

.PatientStatusPopup-module__p-b-10___BQsju {
  padding-bottom: 10px !important;
}

.PatientStatusPopup-module__p-b-12___twvzf {
  padding-bottom: 12px !important;
}

.PatientStatusPopup-module__p-b-16____EIAu {
  padding-bottom: 16px !important;
}

.PatientStatusPopup-module__p-b-18___uRYwy {
  padding-bottom: 18px !important;
}

.PatientStatusPopup-module__p-b-20___gpyoW {
  padding-bottom: 20px !important;
}

.PatientStatusPopup-module__p-b-25___tGrhh {
  padding-bottom: 25px !important;
}

.PatientStatusPopup-module__p-b-30___x97vP {
  padding-bottom: 30px !important;
}

.PatientStatusPopup-module__p-b-50___HuwWF {
  padding-bottom: 50px !important;
}

.PatientStatusPopup-module__p-t-0___CwH2d {
  padding-top: 0 !important;
}

.PatientStatusPopup-module__p-t-12___pDsEX {
  padding-top: 12px !important;
}

.PatientStatusPopup-module__p-t-16___P1hM2 {
  padding-top: 16px !important;
}

.PatientStatusPopup-module__p-t-18___y4ksG {
  padding-top: 18px !important;
}

.PatientStatusPopup-module__p-t-20___qzajx {
  padding-top: 20px !important;
}

.PatientStatusPopup-module__p-t-30___kTAdO {
  padding-top: 30px !important;
}

.PatientStatusPopup-module__p-t-40___rykpg {
  padding-top: 40px !important;
}

.PatientStatusPopup-module__p-t-50___OaE6_ {
  padding-top: 50px !important;
}

.PatientStatusPopup-module__p-l-20___Z5IJU {
  padding-left: 20px !important;
}

.PatientStatusPopup-module__p-l-30___PSGsW {
  padding-left: 30px !important;
}

.PatientStatusPopup-module__p-l-40___Y31wk {
  padding-left: 40px !important;
}

.PatientStatusPopup-module__p-r-16___Yd7xN {
  padding-right: 16px !important;
}

.PatientStatusPopup-module__p-r-20___z6ygD {
  padding-right: 20px !important;
}

.PatientStatusPopup-module__p-r-30___GfRN0 {
  padding-right: 30px !important;
}

.PatientStatusPopup-module__p-r-50___FraZW {
  padding-right: 50px !important;
}

.PatientStatusPopup-module__p-r-60___xuolC {
  padding-right: 60px !important;
}

.PatientStatusPopup-module__m-b-1___zmDsC {
  margin-bottom: 1px !important;
}

.PatientStatusPopup-module__m-b-2___VwsWT {
  margin-bottom: 2px !important;
}

.PatientStatusPopup-module__m-b-6___X_sYD {
  margin-bottom: 6px !important;
}

.PatientStatusPopup-module__m-b-8___t_3v0 {
  margin-bottom: 8px !important;
}

.PatientStatusPopup-module__m-b-10___cG1jK {
  margin-bottom: 10px !important;
}

.PatientStatusPopup-module__m-b-14___J7gJp {
  margin-bottom: 14px !important;
}

.PatientStatusPopup-module__m-b-16___g1laU {
  margin-bottom: 16px !important;
}

.PatientStatusPopup-module__m-b-20___I23h0 {
  margin-bottom: 20px !important;
}

.PatientStatusPopup-module__m-b-22___Ea3mB {
  margin-bottom: 22px !important;
}

.PatientStatusPopup-module__m-b-24____K2sw {
  margin-bottom: 24px !important;
}

.PatientStatusPopup-module__m-b-30___SA9n9 {
  margin-bottom: 30px !important;
}

.PatientStatusPopup-module__m-b-32___PodD_ {
  margin-bottom: 32px !important;
}

.PatientStatusPopup-module__m-b-40___sPDyd {
  margin-bottom: 40px !important;
}

.PatientStatusPopup-module__m-t-2___HVJUI {
  margin-top: 2px !important;
}

.PatientStatusPopup-module__m-t-3___AotDy {
  margin-top: 3px !important;
}

.PatientStatusPopup-module__m-t-4___qpnMa {
  margin-top: 4px !important;
}

.PatientStatusPopup-module__m-t-5___tlqTZ {
  margin-top: 5px !important;
}

.PatientStatusPopup-module__m-t-8___Da_Sh {
  margin-top: 8px !important;
}

.PatientStatusPopup-module__m-t-10___legIL {
  margin-top: 10px !important;
}

.PatientStatusPopup-module__m-t-15___jD9XU {
  margin-top: 15px !important;
}

.PatientStatusPopup-module__m-t-16___O4YJq {
  margin-top: 16px !important;
}

.PatientStatusPopup-module__m-t-20___TlG73 {
  margin-top: 20px !important;
}

.PatientStatusPopup-module__m-t-22___oNQ8Z {
  margin-top: 22px !important;
}

.PatientStatusPopup-module__m-t-30___ggULe {
  margin-top: 30px !important;
}

.PatientStatusPopup-module__m-t-32___wEv9E {
  margin-top: 32px !important;
}

.PatientStatusPopup-module__m-l-auto___rSbLO {
  margin-left: auto !important;
}

.PatientStatusPopup-module__m-l-4___EOpGO {
  margin-left: 4px !important;
}

.PatientStatusPopup-module__m-l-5___Hi09Z {
  margin-left: 5px !important;
}

.PatientStatusPopup-module__m-l-6___DljJV {
  margin-left: 6px !important;
}

.PatientStatusPopup-module__m-l-8___PlJ_L {
  margin-left: 8px !important;
}

.PatientStatusPopup-module__m-l-10___Y5fwR {
  margin-left: 10px !important;
}

.PatientStatusPopup-module__m-l-16___srF2q {
  margin-left: 16px !important;
}

.PatientStatusPopup-module__m-l-20___rdwoN {
  margin-left: 20px !important;
}

.PatientStatusPopup-module__m-l-24___EZpUd {
  margin-left: 24px !important;
}

.PatientStatusPopup-module__m-l-30___JO8k1 {
  margin-left: 30px !important;
}

.PatientStatusPopup-module__m-l-35___eKxnr {
  margin-left: 35px !important;
}

.PatientStatusPopup-module__m-l-40___VNx8s {
  margin-left: 40px !important;
}

.PatientStatusPopup-module__m-r-8___zx2cH {
  margin-right: 8px !important;
}

.PatientStatusPopup-module__m-r-10___SuYHL {
  margin-right: 10px !important;
}

.PatientStatusPopup-module__m-r-16___XhTsS {
  margin-right: 16px !important;
}

.PatientStatusPopup-module__m-r-20___W2rPF {
  margin-right: 20px !important;
}

.PatientStatusPopup-module__m-r-24___eFcby {
  margin-right: 24px !important;
}

.PatientStatusPopup-module__m-r-30___HBUSo {
  margin-right: 30px !important;
}

.PatientStatusPopup-module__m-r-40___Teoxl {
  margin-right: 40px !important;
}

.PatientStatusPopup-module__border-r-3___MAoi6 {
  border-radius: 3px !important;
}

.PatientStatusPopup-module__border-r-4___M0KeP {
  border-radius: 4px !important;
}

.PatientStatusPopup-module__border-r-6___Wiflh {
  border-radius: 6px !important;
}

.PatientStatusPopup-module__border-r-10___M5PZW {
  border-radius: 10px !important;
}

.PatientStatusPopup-module__border-r-12___m4dy0 {
  border-radius: 12px !important;
}

.PatientStatusPopup-module__border-r-16___uIhoW {
  border-radius: 16px !important;
}

.PatientStatusPopup-module__border-r-50___EdYao {
  border-radius: 50% !important;
}

.PatientStatusPopup-module__primary-border___iugkD {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientStatusPopup-module__primary-border-b___qsYRz {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientStatusPopup-module__primary-border-t___Dp0tD {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientStatusPopup-module__primary-border-l___rrNAb {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientStatusPopup-module__primary-border-r___ZbLCy {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientStatusPopup-module__secondary-border___XuyW6 {
  border: 1px solid #637768;
}

.PatientStatusPopup-module__secondary-border-b___vckrB {
  border-bottom: 1px solid #637768;
}

.PatientStatusPopup-module__secondary-border-t___lSby4 {
  border-top: 1px solid #637768;
}

.PatientStatusPopup-module__secondary-border-l___x7m6g {
  border-left: 1px solid #637768;
}

.PatientStatusPopup-module__secondary-border-r___RrVf7 {
  border-right: 1px solid #637768;
}

.PatientStatusPopup-module__gap-0___oxzg0 {
  gap: 0 !important;
}

.PatientStatusPopup-module__gap-2___LHeoZ {
  gap: 2px !important;
}

.PatientStatusPopup-module__gap-4___rXte_ {
  gap: 4px !important;
}

.PatientStatusPopup-module__gap-5___ngIi4 {
  gap: 5px !important;
}

.PatientStatusPopup-module__gap-6___qHz2P {
  gap: 6px !important;
}

.PatientStatusPopup-module__gap-8___UD57s {
  gap: 8px !important;
}

.PatientStatusPopup-module__gap-10___RSFcr {
  gap: 10px !important;
}

.PatientStatusPopup-module__gap-12___ZfMYs {
  gap: 12px !important;
}

.PatientStatusPopup-module__gap-14___Lb6zR {
  gap: 14px !important;
}

.PatientStatusPopup-module__gap-16___wLLmh {
  gap: 16px !important;
}

.PatientStatusPopup-module__gap-18___pTq22 {
  gap: 18px !important;
}

.PatientStatusPopup-module__gap-20___c1M8p {
  gap: 20px !important;
}

.PatientStatusPopup-module__gap-24___nx8en {
  gap: 24px !important;
}

.PatientStatusPopup-module__gap-26___MN2oD {
  gap: 26px !important;
}

.PatientStatusPopup-module__gap-30___J6Qox {
  gap: 30px !important;
}

.PatientStatusPopup-module__gap-32___cvCMa {
  gap: 32px !important;
}

.PatientStatusPopup-module__gap-40___ugElm {
  gap: 40px !important;
}

.PatientStatusPopup-module__gap-50___W1nKA {
  gap: 50px !important;
}

.PatientStatusPopup-module__flex-1____3ttc {
  flex: 1;
}

.PatientStatusPopup-module__flex-none___vo41b {
  flex: none !important;
}

.PatientStatusPopup-module__flex-column___XpmwV {
  display: flex;
  flex-direction: column !important;
}

.PatientStatusPopup-module__flex-row___Uq8EX {
  display: flex;
  flex-direction: row !important;
}

.PatientStatusPopup-module__vertically-centered___pYD6u {
  display: flex;
  align-items: center !important;
}

.PatientStatusPopup-module__horizontally-centered___QsSZD {
  display: flex;
  justify-content: center !important;
}

.PatientStatusPopup-module__horizontally-end___XrPOE {
  display: flex;
  justify-content: end !important;
}

.PatientStatusPopup-module__vertically-start___ljsws {
  display: flex;
  align-items: start !important;
}

.PatientStatusPopup-module__space-between___Kff6b {
  display: flex;
  justify-content: space-between !important;
}

.PatientStatusPopup-module__flex-wrap___GOpU0 {
  flex-wrap: wrap !important;
}

.PatientStatusPopup-module__height-100___jMpvo {
  height: 100%;
}

.PatientStatusPopup-module__width-50___zdr2p {
  width: 50% !important;
}

.PatientStatusPopup-module__width-100___tvxXJ {
  width: 100%;
}

.PatientStatusPopup-module__cursor-pointer___SGrKb {
  cursor: pointer;
}

.PatientStatusPopup-module__cursor-not-allowed___hbGIM {
  cursor: not-allowed !important;
}

.PatientStatusPopup-module__absolute-centered___cPxCM {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientStatusPopup-module__absolute___wn8Yi {
  position: absolute;
}

.PatientStatusPopup-module__relative___bs4XR {
  position: relative;
}

.PatientStatusPopup-module__fixed___ONf8x {
  position: fixed;
}

.PatientStatusPopup-module__visible___RgCL1 {
  opacity: 1;
}

.PatientStatusPopup-module__invisible___xyiog {
  opacity: 0;
}

.PatientStatusPopup-module__col-90___gfSDS {
  width: 90% !important;
}

.PatientStatusPopup-module__col-auto___n6ePl {
  width: auto !important;
}

.PatientStatusPopup-module__medical-tabs___jB77H {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientStatusPopup-module__medical-table-new___b9hZz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientStatusPopup-module__medical-table-new___b9hZz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientStatusPopup-module__medical-table-new___b9hZz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientStatusPopup-module__medical-table-new___b9hZz::-webkit-scrollbar-track {
  display: none;
}
.PatientStatusPopup-module__medical-table-new___b9hZz.PatientStatusPopup-module__no-pagination___ffk3w {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientStatusPopup-module__medical-table-new___b9hZz.PatientStatusPopup-module__no-pagination___ffk3w:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientStatusPopup-module__medical-table-new___b9hZz.PatientStatusPopup-module__no-pagination___ffk3w::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientStatusPopup-module__medical-table-new___b9hZz.PatientStatusPopup-module__no-pagination___ffk3w::-webkit-scrollbar-track {
  display: none;
}

.PatientStatusPopup-module__medical-table-empty___sxDp9 {
  padding: 14px 40px !important;
}

.PatientStatusPopup-module__icon-btn___NZo5r {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientStatusPopup-module__search-icon___rcoez {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientStatusPopup-module__disable-select____FoRP {
  user-select: none;
}

.PatientStatusPopup-module__break-word___gZAK8 {
  word-break: break-word;
}

.PatientStatusPopup-module__popup-clear-btn___ccnNn {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientStatusPopup-module__scroll-m-b-20___ZS82r {
  scroll-margin-bottom: 20px;
}

.PatientStatusPopup-module__subtitle___IDM6k {
  font-family: var(--font-family);
  font-weight: 400;
  color: black;
  padding: 20px 30px;
}

.PatientStatusPopup-module__buttonsContainer___uIJfS {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 20px 30px 20px 0;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}
.PatientStatusPopup-module__buttonsContainer___uIJfS .PatientStatusPopup-module__button___oTNvD {
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/PatientStatusPopup/PatientStatusPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBAFmD;EFrBnD,YAAA;EACA,kBAAA;AA+pBF;;AA5pBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,SAAA;EACA,2CAAA;AA+pBF;AA7pBE;EACE,YAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.subtitle {\n  @include get-font();\n  color: black;\n  padding: 20px 30px;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  padding: 20px 30px 20px 0;\n  gap: 16px;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n\n  .button {\n    height: 40px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientStatusPopup-module__font-s-10___Efg1b`,
	"fontS12": `PatientStatusPopup-module__font-s-12___WIWaV`,
	"fontS13": `PatientStatusPopup-module__font-s-13___YbKmV`,
	"fontS14": `PatientStatusPopup-module__font-s-14___M7wvE`,
	"fontS15": `PatientStatusPopup-module__font-s-15___ex1nF`,
	"fontS16": `PatientStatusPopup-module__font-s-16___XxtIg`,
	"fontS18": `PatientStatusPopup-module__font-s-18___C3FmU`,
	"fontS20": `PatientStatusPopup-module__font-s-20___BxfCM`,
	"fontS22": `PatientStatusPopup-module__font-s-22___oaZB3`,
	"fontS28": `PatientStatusPopup-module__font-s-28___ZnMtG`,
	"fontW400": `PatientStatusPopup-module__font-w-400___B4KgP`,
	"fontW500": `PatientStatusPopup-module__font-w-500___tLRYz`,
	"fontW600": `PatientStatusPopup-module__font-w-600___tiEUX`,
	"fontW700": `PatientStatusPopup-module__font-w-700___sGzom`,
	"p5": `PatientStatusPopup-module__p-5___INZUo`,
	"p12": `PatientStatusPopup-module__p-12___v4aeF`,
	"p16": `PatientStatusPopup-module__p-16___rCpEz`,
	"p30": `PatientStatusPopup-module__p-30___ijJJh`,
	"pB0": `PatientStatusPopup-module__p-b-0___fWNig`,
	"pB5": `PatientStatusPopup-module__p-b-5___ALaYa`,
	"pB10": `PatientStatusPopup-module__p-b-10___BQsju`,
	"pB12": `PatientStatusPopup-module__p-b-12___twvzf`,
	"pB16": `PatientStatusPopup-module__p-b-16____EIAu`,
	"pB18": `PatientStatusPopup-module__p-b-18___uRYwy`,
	"pB20": `PatientStatusPopup-module__p-b-20___gpyoW`,
	"pB25": `PatientStatusPopup-module__p-b-25___tGrhh`,
	"pB30": `PatientStatusPopup-module__p-b-30___x97vP`,
	"pB50": `PatientStatusPopup-module__p-b-50___HuwWF`,
	"pT0": `PatientStatusPopup-module__p-t-0___CwH2d`,
	"pT12": `PatientStatusPopup-module__p-t-12___pDsEX`,
	"pT16": `PatientStatusPopup-module__p-t-16___P1hM2`,
	"pT18": `PatientStatusPopup-module__p-t-18___y4ksG`,
	"pT20": `PatientStatusPopup-module__p-t-20___qzajx`,
	"pT30": `PatientStatusPopup-module__p-t-30___kTAdO`,
	"pT40": `PatientStatusPopup-module__p-t-40___rykpg`,
	"pT50": `PatientStatusPopup-module__p-t-50___OaE6_`,
	"pL20": `PatientStatusPopup-module__p-l-20___Z5IJU`,
	"pL30": `PatientStatusPopup-module__p-l-30___PSGsW`,
	"pL40": `PatientStatusPopup-module__p-l-40___Y31wk`,
	"pR16": `PatientStatusPopup-module__p-r-16___Yd7xN`,
	"pR20": `PatientStatusPopup-module__p-r-20___z6ygD`,
	"pR30": `PatientStatusPopup-module__p-r-30___GfRN0`,
	"pR50": `PatientStatusPopup-module__p-r-50___FraZW`,
	"pR60": `PatientStatusPopup-module__p-r-60___xuolC`,
	"mB1": `PatientStatusPopup-module__m-b-1___zmDsC`,
	"mB2": `PatientStatusPopup-module__m-b-2___VwsWT`,
	"mB6": `PatientStatusPopup-module__m-b-6___X_sYD`,
	"mB8": `PatientStatusPopup-module__m-b-8___t_3v0`,
	"mB10": `PatientStatusPopup-module__m-b-10___cG1jK`,
	"mB14": `PatientStatusPopup-module__m-b-14___J7gJp`,
	"mB16": `PatientStatusPopup-module__m-b-16___g1laU`,
	"mB20": `PatientStatusPopup-module__m-b-20___I23h0`,
	"mB22": `PatientStatusPopup-module__m-b-22___Ea3mB`,
	"mB24": `PatientStatusPopup-module__m-b-24____K2sw`,
	"mB30": `PatientStatusPopup-module__m-b-30___SA9n9`,
	"mB32": `PatientStatusPopup-module__m-b-32___PodD_`,
	"mB40": `PatientStatusPopup-module__m-b-40___sPDyd`,
	"mT2": `PatientStatusPopup-module__m-t-2___HVJUI`,
	"mT3": `PatientStatusPopup-module__m-t-3___AotDy`,
	"mT4": `PatientStatusPopup-module__m-t-4___qpnMa`,
	"mT5": `PatientStatusPopup-module__m-t-5___tlqTZ`,
	"mT8": `PatientStatusPopup-module__m-t-8___Da_Sh`,
	"mT10": `PatientStatusPopup-module__m-t-10___legIL`,
	"mT15": `PatientStatusPopup-module__m-t-15___jD9XU`,
	"mT16": `PatientStatusPopup-module__m-t-16___O4YJq`,
	"mT20": `PatientStatusPopup-module__m-t-20___TlG73`,
	"mT22": `PatientStatusPopup-module__m-t-22___oNQ8Z`,
	"mT30": `PatientStatusPopup-module__m-t-30___ggULe`,
	"mT32": `PatientStatusPopup-module__m-t-32___wEv9E`,
	"mLAuto": `PatientStatusPopup-module__m-l-auto___rSbLO`,
	"mL4": `PatientStatusPopup-module__m-l-4___EOpGO`,
	"mL5": `PatientStatusPopup-module__m-l-5___Hi09Z`,
	"mL6": `PatientStatusPopup-module__m-l-6___DljJV`,
	"mL8": `PatientStatusPopup-module__m-l-8___PlJ_L`,
	"mL10": `PatientStatusPopup-module__m-l-10___Y5fwR`,
	"mL16": `PatientStatusPopup-module__m-l-16___srF2q`,
	"mL20": `PatientStatusPopup-module__m-l-20___rdwoN`,
	"mL24": `PatientStatusPopup-module__m-l-24___EZpUd`,
	"mL30": `PatientStatusPopup-module__m-l-30___JO8k1`,
	"mL35": `PatientStatusPopup-module__m-l-35___eKxnr`,
	"mL40": `PatientStatusPopup-module__m-l-40___VNx8s`,
	"mR8": `PatientStatusPopup-module__m-r-8___zx2cH`,
	"mR10": `PatientStatusPopup-module__m-r-10___SuYHL`,
	"mR16": `PatientStatusPopup-module__m-r-16___XhTsS`,
	"mR20": `PatientStatusPopup-module__m-r-20___W2rPF`,
	"mR24": `PatientStatusPopup-module__m-r-24___eFcby`,
	"mR30": `PatientStatusPopup-module__m-r-30___HBUSo`,
	"mR40": `PatientStatusPopup-module__m-r-40___Teoxl`,
	"borderR3": `PatientStatusPopup-module__border-r-3___MAoi6`,
	"borderR4": `PatientStatusPopup-module__border-r-4___M0KeP`,
	"borderR6": `PatientStatusPopup-module__border-r-6___Wiflh`,
	"borderR10": `PatientStatusPopup-module__border-r-10___M5PZW`,
	"borderR12": `PatientStatusPopup-module__border-r-12___m4dy0`,
	"borderR16": `PatientStatusPopup-module__border-r-16___uIhoW`,
	"borderR50": `PatientStatusPopup-module__border-r-50___EdYao`,
	"primaryBorder": `PatientStatusPopup-module__primary-border___iugkD`,
	"primaryBorderB": `PatientStatusPopup-module__primary-border-b___qsYRz`,
	"primaryBorderT": `PatientStatusPopup-module__primary-border-t___Dp0tD`,
	"primaryBorderL": `PatientStatusPopup-module__primary-border-l___rrNAb`,
	"primaryBorderR": `PatientStatusPopup-module__primary-border-r___ZbLCy`,
	"secondaryBorder": `PatientStatusPopup-module__secondary-border___XuyW6`,
	"secondaryBorderB": `PatientStatusPopup-module__secondary-border-b___vckrB`,
	"secondaryBorderT": `PatientStatusPopup-module__secondary-border-t___lSby4`,
	"secondaryBorderL": `PatientStatusPopup-module__secondary-border-l___x7m6g`,
	"secondaryBorderR": `PatientStatusPopup-module__secondary-border-r___RrVf7`,
	"gap0": `PatientStatusPopup-module__gap-0___oxzg0`,
	"gap2": `PatientStatusPopup-module__gap-2___LHeoZ`,
	"gap4": `PatientStatusPopup-module__gap-4___rXte_`,
	"gap5": `PatientStatusPopup-module__gap-5___ngIi4`,
	"gap6": `PatientStatusPopup-module__gap-6___qHz2P`,
	"gap8": `PatientStatusPopup-module__gap-8___UD57s`,
	"gap10": `PatientStatusPopup-module__gap-10___RSFcr`,
	"gap12": `PatientStatusPopup-module__gap-12___ZfMYs`,
	"gap14": `PatientStatusPopup-module__gap-14___Lb6zR`,
	"gap16": `PatientStatusPopup-module__gap-16___wLLmh`,
	"gap18": `PatientStatusPopup-module__gap-18___pTq22`,
	"gap20": `PatientStatusPopup-module__gap-20___c1M8p`,
	"gap24": `PatientStatusPopup-module__gap-24___nx8en`,
	"gap26": `PatientStatusPopup-module__gap-26___MN2oD`,
	"gap30": `PatientStatusPopup-module__gap-30___J6Qox`,
	"gap32": `PatientStatusPopup-module__gap-32___cvCMa`,
	"gap40": `PatientStatusPopup-module__gap-40___ugElm`,
	"gap50": `PatientStatusPopup-module__gap-50___W1nKA`,
	"flex1": `PatientStatusPopup-module__flex-1____3ttc`,
	"flexNone": `PatientStatusPopup-module__flex-none___vo41b`,
	"flexColumn": `PatientStatusPopup-module__flex-column___XpmwV`,
	"flexRow": `PatientStatusPopup-module__flex-row___Uq8EX`,
	"verticallyCentered": `PatientStatusPopup-module__vertically-centered___pYD6u`,
	"horizontallyCentered": `PatientStatusPopup-module__horizontally-centered___QsSZD`,
	"horizontallyEnd": `PatientStatusPopup-module__horizontally-end___XrPOE`,
	"verticallyStart": `PatientStatusPopup-module__vertically-start___ljsws`,
	"spaceBetween": `PatientStatusPopup-module__space-between___Kff6b`,
	"flexWrap": `PatientStatusPopup-module__flex-wrap___GOpU0`,
	"height100": `PatientStatusPopup-module__height-100___jMpvo`,
	"width50": `PatientStatusPopup-module__width-50___zdr2p`,
	"width100": `PatientStatusPopup-module__width-100___tvxXJ`,
	"cursorPointer": `PatientStatusPopup-module__cursor-pointer___SGrKb`,
	"cursorNotAllowed": `PatientStatusPopup-module__cursor-not-allowed___hbGIM`,
	"absoluteCentered": `PatientStatusPopup-module__absolute-centered___cPxCM`,
	"absolute": `PatientStatusPopup-module__absolute___wn8Yi`,
	"relative": `PatientStatusPopup-module__relative___bs4XR`,
	"fixed": `PatientStatusPopup-module__fixed___ONf8x`,
	"visible": `PatientStatusPopup-module__visible___RgCL1`,
	"invisible": `PatientStatusPopup-module__invisible___xyiog`,
	"col90": `PatientStatusPopup-module__col-90___gfSDS`,
	"colAuto": `PatientStatusPopup-module__col-auto___n6ePl`,
	"medicalTabs": `PatientStatusPopup-module__medical-tabs___jB77H`,
	"medicalTableNew": `PatientStatusPopup-module__medical-table-new___b9hZz`,
	"noPagination": `PatientStatusPopup-module__no-pagination___ffk3w`,
	"medicalTableEmpty": `PatientStatusPopup-module__medical-table-empty___sxDp9`,
	"iconBtn": `PatientStatusPopup-module__icon-btn___NZo5r`,
	"searchIcon": `PatientStatusPopup-module__search-icon___rcoez`,
	"disableSelect": `PatientStatusPopup-module__disable-select____FoRP`,
	"breakWord": `PatientStatusPopup-module__break-word___gZAK8`,
	"popupClearBtn": `PatientStatusPopup-module__popup-clear-btn___ccnNn`,
	"scrollMB20": `PatientStatusPopup-module__scroll-m-b-20___ZS82r`,
	"subtitle": `PatientStatusPopup-module__subtitle___IDM6k`,
	"buttonsContainer": `PatientStatusPopup-module__buttonsContainer___uIJfS`,
	"button": `PatientStatusPopup-module__button___oTNvD`
};
module.exports = ___CSS_LOADER_EXPORT___;
